import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const setFatalError = (error: Error, solveTo: string) =>
  produce((draft: Draft<State>) => {
    draft.fatalError = { error, solveTo };
  });

export const disposeFatalError = () =>
  produce((draft: Draft<State>) => {
    draft.fatalError = initialState.fatalError;
  });
